module.exports = __webpack_public_path__ + "static/lydie-Fun-db690ac006bc3576a502c7175dfbb1f9.jpg";